(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("mobx-state-tree"), require("react"), require("react-dom"), require("mobx-react"));
	else if(typeof define === 'function' && define.amd)
		define("sheetforge", ["mobx", "mobx-state-tree", "react", "react-dom", "mobx-react"], factory);
	else if(typeof exports === 'object')
		exports["sheetforge"] = factory(require("mobx"), require("mobx-state-tree"), require("react"), require("react-dom"), require("mobx-react"));
	else
		root["sheetforge"] = factory(root["mobx"], root["mobx-state-tree"], root["react"], root["react-dom"], root["mobx-react"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE_VBo9__, __WEBPACK_EXTERNAL_MODULE_YeEv__, __WEBPACK_EXTERNAL_MODULE_cDcd__, __WEBPACK_EXTERNAL_MODULE_faye__, __WEBPACK_EXTERNAL_MODULE_sGQ9__) {
return 